import "./Column.scss";
import FieldClone from "../Field/FieldClone";
export default function ColumnClone({ column }) {
    return (
        <div className="column-clone">
            {column.data.map((field, fieldIndex) => (
                <FieldClone field={field} />
            ))}
        </div>
    );
}
